import gateway from '../../network/gateway'
import {
    getApiBaseUrlLkProxy,
    getHeaders,
    getLKRequestConfig
} from './networkLayer'
import { ReqConfigModel } from './api.types'
import {
    ErrorFN,
    GatewayRequestModel,
    MethodType
} from '../../network/gateway.types'

/**
 * Extracts params from config and sends request to server, then returns response
 * @param method Request method
 * @param url Request URL
 * @param data Request payload/data
 * @param config Request configuration
 * @param errorFN Error callback function
 * @returns Server response
 */
export default async (
    method: MethodType,
    url: string,
    data: GatewayRequestModel['payload'] = {},
    config: ReqConfigModel,
    errorFN: ErrorFN<ReqConfigModel>
) => {
    const requestConfig = getLKRequestConfig(config)
    const configParams = requestConfig.params || {}
    return gateway({
        method,
        url,
        payload: data,
        params: { ...config.params, ...configParams },
        headers: getHeaders(config.jwt, config.headers),
        base_url: getApiBaseUrlLkProxy(
            config.baseKey || 'api',
            config.region ?? ''
        ),
        config: requestConfig,
        responseType: config.responseType,
        errorFN
    })
}
